(() => {
  if (window.__cpHomeInit) return;
  window.__cpHomeInit = true;

  const qs = (root, selector) => root.querySelector(selector);
  const qsa = (root, selector) => Array.from(root.querySelectorAll(selector));
  const isProductPage = window.location.pathname.indexOf("/products/") === 0;

  function injectProductShellStyles() {
    if (document.getElementById("cp-product-shell-restore-style")) return;

    const style = document.createElement("style");
    style.id = "cp-product-shell-restore-style";
    style.textContent = `
      .cp-js-product-shell-announcement {
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        background: #ffffff;
        text-align: center;
      }

      .cp-js-product-shell-announcement a {
        display: block;
        margin: 0 auto;
        padding: 11px 16px;
        color: #000000;
        font-size: 0.75rem;
        font-weight: 600;
        letter-spacing: 0.02em;
        text-decoration: none;
      }

      .cp-js-product-shell-header {
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        background: #ffffff;
      }

      .cp-js-product-shell-header__inner {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
        gap: 12px;
        max-width: 1360px;
        margin: 0 auto;
        padding: 14px 24px;
      }

      .cp-js-product-shell-header__action {
        display: inline-flex;
        align-items: center;
        color: #000000;
        text-decoration: none;
      }

      .cp-js-product-shell-header__action--search {
        justify-self: start;
      }

      .cp-js-product-shell-header__action--cart {
        justify-self: end;
        position: relative;
      }

      .cp-js-product-shell-header__logo-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
      }

      .cp-js-product-shell-header__logo-link img {
        display: block;
        height: auto;
        max-height: 36px;
        width: auto;
        max-width: min(220px, 48vw);
      }

      .cp-js-product-shell-header__logo-link svg {
        display: block;
        max-width: min(220px, 48vw);
        height: auto;
      }

      .cp-js-product-shell-header__cart-count {
        position: absolute;
        top: -5px;
        right: -8px;
        min-width: 18px;
        height: 18px;
        border-radius: 999px;
        background: #000000;
        color: #ffffff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 5px;
        font-size: 10px;
        font-weight: 700;
        line-height: 1;
      }

      .cp-js-product-shell-footer {
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        background: #ffffff;
      }

      .cp-js-product-shell-footer__inner {
        max-width: 1360px;
        margin: 0 auto;
        padding: 20px 16px 28px;
        text-align: center;
        color: rgba(0, 0, 0, 0.72);
        font-size: 0.75rem;
        line-height: 1.4;
      }

      .product-details .variant-option__button-label {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.18);
        border-radius: 999px;
        color: #000000;
        display: inline-flex;
        justify-content: center;
        min-height: 44px;
        padding: 0 18px;
        transition:
          background-color 0.2s ease,
          border-color 0.2s ease,
          color 0.2s ease,
          box-shadow 0.2s ease;
      }

      .product-details .variant-option__button-label:hover {
        background: rgba(0, 0, 0, 0.04);
        border-color: rgba(0, 0, 0, 0.28);
      }

      .product-details .variant-option__button-label:has(input:checked) {
        background: #000000;
        border-color: rgba(0, 0, 0, 0.72);
        color: #ffffff;
      }

      .product-details .variant-option__button-label:has(input:focus-visible) {
        outline: 2px solid rgba(0, 0, 0, 0.24);
        outline-offset: 2px;
      }

      .product-details .product-form-buttons .quantity-selector {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.18);
        border-radius: 999px;
        min-height: 48px;
        overflow: hidden;
      }

      .product-details .product-form-buttons .quantity-selector input {
        background: transparent;
        border: 0;
        color: #000000;
        min-width: 44px;
      }

      .product-details .product-form-buttons .quantity-minus,
      .product-details .product-form-buttons .quantity-plus {
        min-width: 44px;
        position: relative;
        width: 44px;
      }

      .product-details .product-form-buttons .quantity-minus::after,
      .product-details .product-form-buttons .quantity-plus::before {
        background: rgba(0, 0, 0, 0.14);
        content: "";
        position: absolute;
        top: 10px;
        bottom: 10px;
        width: 1px;
      }

      .product-details .product-form-buttons .quantity-minus::after {
        inset-inline-end: 0;
      }

      .product-details .product-form-buttons .quantity-plus::before {
        inset-inline-start: 0;
      }

      .product-details .product-form-buttons .add-to-cart-button,
      .sticky-add-to-cart__button.add-to-cart-button {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.18);
        border-radius: 999px;
        box-shadow: none;
        color: #000000;
        min-height: 48px;
        transition:
          background-color 0.2s ease,
          border-color 0.2s ease,
          color 0.2s ease;
      }

      .product-details .product-form-buttons .add-to-cart-button:hover,
      .sticky-add-to-cart__button.add-to-cart-button:hover {
        background: #000000;
        border-color: rgba(0, 0, 0, 0.72);
        color: #ffffff;
      }

      .product-details .product-form-buttons .add-to-cart-button .add-to-cart-text,
      .product-details .product-form-buttons .add-to-cart-button .add-to-cart-icon,
      .sticky-add-to-cart__button.add-to-cart-button .add-to-cart-text,
      .sticky-add-to-cart__button.add-to-cart-button .add-to-cart-icon {
        color: inherit;
      }

      @media screen and (max-width: 749px) {
        .cp-js-product-shell-header__inner {
          padding: 12px 16px;
        }

        .cp-js-product-shell-header__logo-link img,
        .cp-js-product-shell-header__logo-link svg {
          max-height: 28px;
          max-width: min(180px, 44vw);
        }
      }
    `;

    document.head.appendChild(style);
  }

  function getProductShellLogoMarkup() {
    const logoLink = document.querySelector(".cp-header__brand-link");
    if (!logoLink) return '<span>My Store</span>';
    return logoLink.innerHTML.trim();
  }

  function getProductShellCartCount() {
    const cartCount = document.querySelector(".cp-header__cart-count");
    return cartCount ? cartCount.textContent.trim() : "";
  }

  function restoreProductShell() {
    if (document.body.dataset.cpProductShellRestored === "true") return;

    injectProductShellStyles();

    const logoMarkup = getProductShellLogoMarkup();
    const cartCount = getProductShellCartCount();
    const year = new Date().getFullYear();

    const announcementSection = document.querySelector(".cp-announcement")?.closest(".shopify-section");
    if (announcementSection) {
      announcementSection.innerHTML = `
        <div class="cp-js-product-shell-announcement">
          <a href="/collections/shop-all">FREE SHIPPING ON ALL ORDERS</a>
        </div>
      `;
    }

    const headerSection = document.querySelector(".cp-header")?.closest(".shopify-section");
    if (headerSection) {
      headerSection.innerHTML = `
        <header class="cp-js-product-shell-header">
          <div class="cp-js-product-shell-header__inner">
            <a class="cp-js-product-shell-header__action cp-js-product-shell-header__action--search" href="/search" aria-label="Search">
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M22.277 20.83C23.052 21.596 21.889 22.745 21.113 21.98L17.061 17.977C16.286 17.211 12.753 13.738 13.529 14.504L14.715 13.362L22.277 20.83ZM13.551 14.51A7.796 7.796 0 0 1 8.671 16.214C4.38 16.214 0.9 12.778 0.9 8.54C0.9 4.302 4.382 0.866 8.672 0.866C12.962 0.866 16.441 4.302 16.441 8.54A7.584 7.584 0 0 1 14.716 13.362L18.226 16.828L17.062 17.978L13.551 14.51ZM14.794 8.56C14.794 5.22 12.052 2.511 8.671 2.511C5.29 2.511 2.548 5.22 2.548 8.56C2.548 11.9 5.29 14.609 8.671 14.609C12.052 14.609 14.794 11.9 14.794 8.56Z" fill="currentColor"/>
              </svg>
            </a>
            <a class="cp-js-product-shell-header__logo-link" href="/" aria-label="My Store">${logoMarkup}</a>
            <a class="cp-js-product-shell-header__action cp-js-product-shell-header__action--cart" href="/cart" aria-label="Cart">
              <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M8.938 20.864A1.703 1.703 0 1 1 5.532 20.864A1.703 1.703 0 0 1 8.938 20.864ZM20.45 20.864A1.703 1.703 0 1 1 17.045 20.864A1.703 1.703 0 0 1 20.45 20.864ZM22.45 5.255C23.322 5.255 23.998 6.024 23.884 6.889L22.664 15.989C22.57 16.665 21.995 17.16 21.314 17.16H6.915C6.246 17.16 5.678 16.684 5.57 16.024L3.628 4.243H1.154C0.517 4.243 0 3.728 0 3.093C0 2.458 0.517 1.943 1.154 1.943H4.603C5.173 1.943 5.66 2.353 5.756 2.913L5.991 4.243H22.45ZM21.514 7.555H6.359L7.983 14.86H20.31L21.514 7.555Z" fill="currentColor"/>
              </svg>
              ${
                cartCount
                  ? `<span class="cp-js-product-shell-header__cart-count">${cartCount}</span>`
                  : ""
              }
            </a>
          </div>
        </header>
      `;
    }

    const footerSection = document.querySelector(".cp-footer")?.closest(".shopify-section");
    if (footerSection) {
      footerSection.innerHTML = `
        <div class="cp-js-product-shell-footer">
          <div class="cp-js-product-shell-footer__inner">&copy; Copyright ${year}</div>
        </div>
      `;
    }

    document.documentElement.classList.remove("cp-drawer-open");
    document.body.classList.remove("cp-drawer-open");
    document.body.dataset.cpProductShellRestored = "true";
  }

  if (isProductPage) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", restoreProductShell, { once: true });
    } else {
      restoreProductShell();
    }
    return;
  }

  function initDrawer() {
    const header = document.querySelector("[data-cp-header-root]");
    if (!header) return;

    const toggle = qs(header, "[data-cp-drawer-toggle]");
    const close = qs(header, "[data-cp-drawer-close]");
    const overlay = qs(header, "[data-cp-drawer-overlay]");
    const drawer = qs(header, "[data-cp-drawer]");

    if (!toggle || !close || !overlay || !drawer) return;

    const setOpen = (open) => {
      header.classList.toggle("is-open", open);
      document.documentElement.classList.toggle("cp-drawer-open", open);
      document.body.classList.toggle("cp-drawer-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    };

    toggle.addEventListener("click", () => setOpen(!header.classList.contains("is-open")));
    close.addEventListener("click", () => setOpen(false));
    overlay.addEventListener("click", () => setOpen(false));

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && header.classList.contains("is-open")) {
        setOpen(false);
      }
    });
  }

  function initSearchFallback() {
    qsa(document, '[aria-label="Search"]').forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      if (node.tagName === "A") return;

      node.addEventListener("click", () => {
        window.location.href = "/search";
      });
    });
  }

  function buildDots(root, count) {
    const dots = qs(root, "[data-cp-dots]");
    if (!dots) return [];

    dots.innerHTML = "";
    const nodes = [];

    for (let index = 0; index < count; index += 1) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "cp-rail__dot";
      dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
      dots.appendChild(dot);
      nodes.push(dot);
    }

    return nodes;
  }

  function initCarousels() {
    qsa(document, "[data-cp-carousel]").forEach((root) => {
      const track = qs(root, "[data-cp-track]");
      const prev = qs(root, "[data-cp-prev]");
      const next = qs(root, "[data-cp-next]");
      if (!track) return;

      let dots = [];

      const getPageCount = () => {
        const pageWidth = track.clientWidth || 1;
        return Math.max(1, Math.ceil(track.scrollWidth / pageWidth));
      };

      const getPageIndex = () => {
        const pageWidth = track.clientWidth || 1;
        return Math.round(track.scrollLeft / pageWidth);
      };

      const update = () => {
        const pages = getPageCount();
        const index = Math.min(getPageIndex(), pages - 1);
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);

        if (prev) prev.disabled = track.scrollLeft <= 8;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 8;

        if (qs(root, "[data-cp-dots]")) {
          if (dots.length !== pages) {
            dots = buildDots(root, pages);
            dots.forEach((dot, dotIndex) => {
              dot.addEventListener("click", () => {
                track.scrollTo({
                  left: dotIndex * track.clientWidth,
                  behavior: "smooth"
                });
              });
            });
          }

          dots.forEach((dot, dotIndex) => {
            dot.classList.toggle("is-active", dotIndex === index);
          });
        }
      };

      if (prev) {
        prev.addEventListener("click", () => {
          track.scrollBy({ left: -track.clientWidth, behavior: "smooth" });
        });
      }

      if (next) {
        next.addEventListener("click", () => {
          track.scrollBy({ left: track.clientWidth, behavior: "smooth" });
        });
      }

      track.addEventListener("scroll", () => window.requestAnimationFrame(update), {
        passive: true
      });

      window.addEventListener("resize", update);
      update();
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initDrawer();
    initSearchFallback();
    initCarousels();
  });
})();
